import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { RelatorioListWrapper } from './relatorio-list/RelatorioList'

const RelatorioPage = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/atendimentos'
          element={
            <>
              <PageTitle description={t('pagina.relatorioAtendimentos.descricao')}>
                Relatório de atendimentos
              </PageTitle>
              <RelatorioListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/relatorios/atendimentos' />} />
    </Routes>
  )
}

export default RelatorioPage
